import axios from 'axios';

/**
 * Send the admin back to the login screen when their session is no longer
 * accepted.
 *
 * An admin JWT lasts 90 days and is kept in localStorage, but nothing ever
 * checked whether it was still valid. A stale token simply stayed there and
 * failed every authenticated request, which surfaced as an error message on
 * each page rather than as "you are signed out" - and because some endpoints
 * need no token at all, parts of the dashboard kept working, which made it
 * look like a bug in those pages instead.
 */
const LOGIN_PATH = '/login';

export default function installAuthInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      // 401 is the server saying this credential is not acceptable - expired,
      // malformed, or signed with a different key.
      if (status === 401) {
        try {
          localStorage.removeItem('admin_token');
        } catch {
          // Private browsing; the redirect below still gets them out.
        }
        delete axios.defaults.headers.common.Authorization;

        // Avoid a redirect loop if the login request itself returns 401.
        if (!window.location.pathname.startsWith(LOGIN_PATH)) {
          window.location.replace(LOGIN_PATH);
        }
      }

      return Promise.reject(error);
    }
  );
}
